import { useState } from "react";

import { researchApi } from "../services/researchApi";

type ViewType = "shortlist" | "longlist" | "final" | "all";

export const useEntityExport = (
  trackId: string,
  viewType: ViewType,
  defaultDecisionStates?: string[],
) => {
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportToExcel = async (
    decisionStates?: string[],
    entityIds?: string[],
  ) => {
    if (!trackId) {
      setError("Track ID is required for export");
      return;
    }

    setIsExporting(true);
    setError(null);

    try {
      const blob = await researchApi.exportToExcel(
        trackId,
        viewType,
        entityIds ? undefined : decisionStates || defaultDecisionStates,
        entityIds,
      );

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Generate filename (backend will provide it in Content-Disposition header)
      // But we'll create a fallback just in case
      const timestamp = new Date().toISOString().split("T")[0];
      link.download = `research_${timestamp}.xlsx`;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.error || err.message || "Failed to export entities";
      setError(errorMessage);
      console.error("Export error:", err);
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    isExporting,
    error,
    clearError: () => setError(null),
  };
};
